export default {
    lpTabs: {
        display: {lg: 'flex'},
        flexDirection: {lg: 'column'},
        gap: {lg: 6}
    },
    lpContainer: {
        margin: {lg: '24px 0'}
    },
    lpHeading: {
        padding: {base: '13px 0', lg: 0},
        backgroundColor: {base: 'webTheme.backgroundPrimaryBrand', lg: 'unset'},
        marginBottom: {base: 6, lg: 0}
    },
    lpLevels: {
        display: {base: 'flex'},
        gap: {lg: 2},
        alignItems: {lg: 'stretch'},
        justifyContent: {base: 'center', lg: 'flex-start'}
    },
    lpLevelsWrapper: {
        display: 'flex',
        gap: 2,
        flex: {lg: '1'},
        width: {lg: '100%'},
        maxW: {lg: '50%'},
        backgroundColor: {lg: 'webTheme.backgroundPrimaryBrand'},
        padding: {lg: '16px 0'}
    },
    lpLevel: {
        display: {base: 'flex'},
        flexDirection: {base: 'column'},
        alignItems: {base: 'center'},
        justifyContent: {base: 'center'},
        flex: {base: '1', lg: '1 1 0'},
        width: {base: '100%'},
        backgroundColor: {base: 'webTheme.backgroundPrimaryBrand', lg: 'transparent'}
    },
    lpLevelName: {
        display: {base: 'flex'},
        justifyContent: {base: 'center'},
        textStyle: {base: 'webH3'},
        marginBottom: {base: 2}
    },
    lpLevelDescription: {
        textStyle: {base: 'bodyXsRegular'}
    },
    lpAccItem: {
        borderTop: {base: 0},
        borderBottom: {base: '1px solid'},
        borderColor: {base: 'webTheme.strokeDefault'}
    },
    lpAccItemSx: {
        '&:has(button[aria-expanded="true"])': {
            borderBottomColor: 'transparent'
        }
    },
    lpTab: {
        marginBottom: {lg: 6}
    },
    lpAccBtn: {
        display: {base: 'flex'},
        justifyContent: {base: 'space-between'},
        padding: {base: '12px 0', lg: 0},
        marginTop: {base: 6, lg: 0}
    },
    lpAccPanel: {
        padding: {base: '0 0 24px', lg: 0},
        borderTop: {base: '1px solid', lg: 0},
        borderColor: {base: 'webTheme.strokeDefault'}
    },
    lpContent: {
        display: {lg: 'flex'},
        alignItems: {lg: 'stretch'},
        gap: {lg: 2},
        borderBottom: {lg: '1px solid'},
        borderColor: {lg: 'webBasic.600'}
    },
    lpNameAndDesc: {
        flex: {lg: '1'},
        width: {lg: '100%'},
        maxW: {lg: '50%'},
        cursor: {lg: 'pointer'},
        padding: {lg: '12px 0'}
    },
    lpAccTitle: {
        textStyle: {base: 'webH2'},
        flex: {lg: '1'},
        width: {lg: '100%'},
        maxW: {lg: '50%'},
        paddingTop: {lg: 4},
        paddingBottom: {lg: '35px'}
    },
    lpContentName: {
        textStyle: 'bodyMdRegular',
        display: {lg: 'flex'},
        alignItems: {lg: 'center'},
        marginTop: {base: 4, lg: 0},
        padding: {lg: '16px 0', lg: '12px 0'},
        gap: {lg: 3}
    },
    lpContentDescription: {
        textStyle: 'bodySmRegular',
        marginTop: {base: 3, lg: 0},
        marginBottom: {base: 4, lg: 0},
        paddingBottom: {lg: 3},
        paddingLeft: {lg: 9}
    },
    lpCards: {
        display: {base: 'flex'},
        gap: {lg: 2},
        flex: {lg: '1'},
        width: {lg: '100%'},
        maxW: {lg: '50%'},
        borderBottom: {base: '1px solid', lg: 0},
        borderColor: {base: 'webBasic.600'},
    },
    lpCard: {
        display: {base: 'flex'},
        alignItems: {base: 'center'},
        justifyContent: {base: 'center'},
        flex: {base: '1', lg: '1 1 0'},
        width: {base: '100%'}
    },
    lpCardIcon: {
        width: '20px',
        height: '20px',
        marginRight: 1
    },
    lpCardText: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        textStyle: 'bodyMdRegular',
        paddingTop: {base: '26px'},
        paddingBottom: {base: '26px'}
    }
}
